import React from 'react';
import { compose } from 'ramda';

import styleFile from './textAreaField.js';
import PropertyManager from '@synergycms_core/components/HoC/propertyManager';
import { withThemeJSS } from '@synergycms_core/components/providers/themeProvider';
import { withForm } from './';

export default compose(
  withForm(),
  PropertyManager(['form', 'formModel', 'validations', 'model', 'css', 'validationsFields', 'defaultValue', 'maxLength']),
  withThemeJSS({styleFile})
)(
  class TextAreaField extends React.Component {
    static displayName = 'TextAreaField';
    constructor(props) {
      super(props);

      const { form, model, defaultValue = '', validations = [], validationsFields } = this.props.config;

      form.subscribe({
        model: model,
        onChange: this.onChange,
        forceUpdate: this.forceUpdate,
        validations: validations,
        defaultValue: defaultValue,
        value: defaultValue,
        validationsFields: validationsFields
      });

      this.state = {
        value: defaultValue
      };
    }

    /*componentDidUpdate = () => {
      //this.subscribe();
    };*/

    componentDidMount = () => {};

    onBlur = e => {
      const { config } = this.props;
      const { form, formModel } = config;
      if (!formModel.visited) {
        form.updateModel(config.model, { visited: true });
      }
      form.onGlobalBlur(config.model);
    };

    onChange = event => {
      const value = event && event.target.value;
      this.setState({ value: value }, () => {
        const { config } = this.props;
        config.form.onGlobalChange(config.model, value);
      });
    };

    render = () => {
      const { value } = this.state;
      const { theme, config } = this.props;
      const { form, formModel, placeHolder, model, css, maxLength } = config;
      return (
        (formModel && (
          <textarea
            className={[form.getValidClass(formModel, css, theme), theme.computedInnerStyle].join(' ')}
            onChange={this.onChange}
            onBlur={this.onBlur}
            name={model}
            placeholder={placeHolder}
            value={value || ''}
            maxLength={maxLength || ''}
          />
        )) ||
        null
      );
    };
  }
);
